// src/components/global-footer/global-footer.tsx
import { tv } from "tailwind-variants";
import { Accordion } from "../accordion/accordion.mjs";
import { AppStores } from "../appstores/appstores.mjs";
import {
  LinkIconList
} from "../link-icon-list/link-icon-list.mjs";
import { LinkList } from "../link-list/link-list.mjs";
import { Link } from "../link/link.mjs";
import { Text } from "../text/text.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
var globalFooter = tv({
  slots: {
    container: "flex flex-col gap-0 p-0 pt-8  border-t-4 border-stroke-interactive bg-neutral-0 items-center",
    message: "flex justify-center text-text-neutral-tertiary justify-end items-end flex-1",
    section: "flex flex-col md:flex-row gap-4 pb-12 ",
    sectionLabel: "text-text-neutral-tertiary font-bold uppercase text-xs pb-6"
  }
});
var style = globalFooter();
var GlobalFooter = ({
  message,
  socials,
  links,
  nextLink,
  appStore,
  seoLinks,
  track
}) => /* @__PURE__ */ jsx("footer", { className: style.container(), children: /* @__PURE__ */ jsxs("div", { className: "max-w-screen-lg w-full md:px-0 px-4", children: [
  /* @__PURE__ */ jsxs("div", { className: style.section(), children: [
    seoLinks && /* @__PURE__ */ jsx("div", { className: "md:w-2/3 md:order-last", children: seoLinks.map(({ label: groupLabel, links: groupLinks }, index) => /* @__PURE__ */ jsx(
      Accordion,
      {
        title: groupLabel,
        borders: index === 0 ? "topAndBottomOnly" : "bottomOnly",
        children: /* @__PURE__ */ jsx(
          "div",
          {
            className: "grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4 pb-6 pt-4",
            children: groupLinks.map((gl, i) => /* @__PURE__ */ jsx(
              Link,
              {
                href: gl.url,
                className: "text-text-neutral-tertiary",
                children: gl.title
              },
              i
            ))
          }
        )
      },
      index
    )) }),
    /* @__PURE__ */ jsx("div", { className: "flex flex-col md:w-1/3", children: links && /* @__PURE__ */ jsx(
      LinkList,
      {
        items: links,
        label: "",
        nextLink,
        isVertical: true,
        track
      }
    ) })
  ] }),
  /* @__PURE__ */ jsxs("div", { className: style.section(), children: [
    socials && /* @__PURE__ */ jsxs("div", { className: "flex flex-col md:w-1/3", children: [
      /* @__PURE__ */ jsx(Text, { variant: "bodySM", className: style.sectionLabel(), children: "Find us on socials" }),
      /* @__PURE__ */ jsx(
        LinkIconList,
        {
          items: socials,
          className: "justify-start",
          track
        }
      )
    ] }),
    appStore && /* @__PURE__ */ jsxs("div", { className: "flex flex-col md:w-1/3", children: [
      /* @__PURE__ */ jsx(Text, { variant: "bodySM", className: style.sectionLabel(), children: "Download the app" }),
      /* @__PURE__ */ jsx(AppStores, { ...appStore, className: "items-left p-0", track })
    ] }),
    /* @__PURE__ */ jsx("div", { className: style.message(), children: /* @__PURE__ */ jsx(Text, { variant: "bodySM", className: "text-text-neutral-placeholder", children: message }) })
  ] })
] }) });
export {
  GlobalFooter
};
